<template>
  <el-dialog title="" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true" class="pdt0-dia" width="80%" top="60px">
    <div class="search-row">
      <span style="margin-left:6px;margin-right:6px;flex:none;">职能模块：</span>
      <el-select v-model="query.职能模块" multiple filterable size="mini" style="margin-left:6px;margin-right:6px;flex:none;">
        <el-option v-for="item in categories" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <span style="margin-left:6px;margin-right:6px;flex:none;">公司</span>
      <el-input v-model="query.公司" class="mr10" size="mini" placeholder="请输入要查询的公司名称"></el-input>
      <el-button size="mini" style="flex:none;" @click="loadData">搜索</el-button>
      <el-button size="mini" style="flex:none;" @click="clearSearch">清空</el-button>
    </div>
    <div v-loading="loading" class="remarks-box">
      <p v-if="showTip" style="text-align: center;color: #a7a7a7;">该条件下目前没有填写过认知哦</p>
      <div
        v-for="(item, index) in showRemarks"
        :key="index"
        :class="item && item.account === user ? 'remark-self' : ''"
      >
        <span class="remark-date">
          {{ dateFormat(item.createdAt) }} <span class="remark-time">{{ dateFormat(item.createdAt, 'HH:MM') }}</span>
          {{ item.account }}<span v-if="item.职能模块">【{{ item.职能模块 }}】</span>
          <span v-if="!query.公司 && item.公司">【{{ item.公司 }}】</span>
        </span>
        <pre class="remark-info pd-10" style="text-indent:0">{{ item.content }}</pre>
      </div>
    </div>
    <el-pagination
      layout="pager"
      :hide-on-single-page="true"
      :page-size="pageSize"
      :total="total"
      @current-change="pageChange">
    </el-pagination>
  </el-dialog>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  data() {
    return {
      visible: false,
      query:{
        职能模块: [],
        公司: '',
      },
      categories:[],
      allRemarks: [],
      page:1,
      pageSize: 5,
      loading:false,
      user:'',
      showTip: false,
    }
  },
  computed: {
    showRemarks(){
      const { allRemarks, page, pageSize } = this
      return allRemarks.slice((page-1)*pageSize,page*pageSize)
    },
    total(){
      return this.allRemarks.length
    },
  },
  async mounted(){
    this.user = app.user.account
    if (!app.categories) await app.getCats()
    this.categories = app.categories.map((v) => v.名称)
  },
  methods: {
    open(company,cate) {
      this.query.公司 = company
      this.query.职能模块 = cate ? [cate] : []
      if (this.query.公司 || this.query.职能模块.length > 0) {
        this.loadData()
      }
      this.visible = true
    },
    dateFormat(val, type) {
      return val ? dateFormat(val, type || 'yyyy-mm-dd') : ''
    },
    pageChange(num){
      this.page = num
    },
    async loadData(){
      if(this.loading) return this.$message.error('搜索中，请稍等')
      this.loading = true
      try {
        const res = await app.service('company').searchComCateCognitionLogs(this.query)
        if (res.status === 'success') {
          this.allRemarks = res.data
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(error.message)
      } finally{
        this.loading = false
        this.showTip = !this.allRemarks.length
      }
    },
    clearSearch(){
      this.query = { 职能模块: [], 公司: '' }
    },
  },
}
</script>
<style>
.pdt0-dia .el-dialog__body {
  padding-top: 0;
}
</style>
<style scoped>
.search-row{
  display: flex;
  align-items: center;
  padding-top: 6px;
  padding-bottom: 6px;
}
.remarks-box{
  min-height: 400px;
  max-height: 600px;
  overflow: auto;
}
</style>

